<template>
    <section>

        <full-loading v-if="carregando"></full-loading>
        <div class='container mt-2' id="content">


            <div class="fixed-action-btn">
                <router-link :to="{name: 'cliente-cadastro'}" class="btn-floating btn-large btn-default btn-default">
                    <i class="material-icons">add</i>
                </router-link>
            </div>

            <div class="input-field" style="text-align: right; margin-bottom: 15px" v-if="!cargoCorretor && !cargoLider">
                <router-link to="/usuarios" class="btn btn-default">
                    Funcionários
                </router-link>
            </div>


            <div class="flex-row">
                <div class="col-xs-12 col-md-10 col-sm-9">
                    <div v-if="pedidos.total === 0" class="white-black white card-panel">
                        Nenhum resultado encontrado
                    </div>
                    <div class="flex-row">
                        <div class="col-xs-12 col-md-6" v-for="(pedido, index) in pedidos.data" :key="pedido.pedido_id">
                            <lead-card >
                                <div slot="actions">
                                    <botao-remover
                                        :identificador="pedido.pedido_id"
                                        :url="'pedido/'+pedido.pedido_id"
                                        style="margin-top: -13px; margin-left: -5px;"
                                        :id="`lead-btn-remover-${index}`"
                                        @deleted="() => pedidos.data.splice(index, 1)"
                                        v-if="cargoDono"
                                    />
                                </div>

                                <lead-card-item :title="pedido.cliente_has_produto.cliente.pessoa.pessoa_nome" special-title></lead-card-item>

                                <div class="col-xs-12 col-md">
                                    <lead-card-item title="Necessidade">
                                        <div class="text-simulador">{{ pedido.cliente_has_produto.cliente.resumo_necessidades.necessidade_segurado | dinheiro }}</div>
                                    </lead-card-item>
                                    <lead-card-item title="Autor">
                                        <div class="text-simulador">{{ pedido.funcionario ? pedido.funcionario.pessoa.pessoa_nome : '[SITE]' }}</div>
                                    </lead-card-item>
                                </div>
                                <div>
                                    <div class="right-align">
                                        <small class=" grey-text">
                                            {{ pedido.data_criacao | formatDate }}
                                        </small>
                                    </div>
                                    <div class="input-field">
                                        <router-link class="btn btn-block btn-default waves-light"
                                        :to="{name: 'gerenciamentoLeadSimulador', params: {pedidoId: pedido.pedido_id}}">
                                            EDITAR
                                        </router-link>
                                    </div>
                                    <div class="input-field">
                                        <router-link class="btn btn-default btn-flex" :to="{name: 'cliente_simulador', params: {id: pedido.cliente_has_produto.cliente.cliente_id}}">
                                            SIMULAR
                                            <span class="btn-icon-circle" :class="{'active' : pedido.cliente_has_produto.cliente.usou_simulador}"></span>
                                        </router-link>
                                    </div>
                                </div>
                            </lead-card>
                        </div>
                    </div>


                    <Pagination
                        v-if="pedidos.last_page > 1"
                        :perPage="pedidos.per_page"
                        :qty="pedidos.total"
                        :setCurrent="paginar"
                        :current="pedidos.current_page"
                    />
                </div>

                <div class="col-xs-12 col-md col-sm">

                    <card title="Filtros">

                        <div class="Search">
                            <span class="Search__title grey-text">Por Lead:</span>
                            <div class="Search input-field input-search">
                                <i class="material-icons">person_outline</i>
                                <input type="text" v-model="pesquisa.pessoa_nome" @input="paginar(1)">
                                <i @click="pesquisa.pessoa_nome = null" class="material-icons md-18 grey-text clear">clear</i>
                            </div>
                        </div>

                        <filtro-por-autores v-if="[1, 2].includes(cargo)" @change="paginar(1)" :autores.sync="pesquisa.funcionarios_ids" />

                        <filtro-por-data
                            @change="paginar(1)"
                            :data_ini.sync="pesquisa.data_ini"
                            :data_fim.sync="pesquisa.data_fim"/>
                    </card>
                </div>
            </div>

        </div>
    </section>
</template>

<script>
import "@/../static/assets/css/custom/flex.css";
import { api } from "@/helpers/api";

import LeadCard from '../common/LeadCard.vue';
import LeadCardItem from '../common/LeadCardItem.vue';
import Pagination from "@/components/common/Pagination/Pagination";

import FiltroPorData from "./listagem/FiltroPorData";
import FiltroPorEstados from "./listagem/FiltroPorEstados";
import FiltroPorLead from "./listagem/FiltroPorLead";
import FiltroPorProdutos from "./listagem/FiltroPorProduto";
import FiltroPorResponsaveis from "./listagem/FiltroPorResponsaveis";
import FiltroPorAutores from "./listagem/FiltroPorAutores";

import BotaoRemover from "@/components/common/BotaoRemover";

import FullLoading from '@/components/common/FullLoading';

import TituloPagina from "@/components/common/TituloPagina";

import Card from "@/components/common/Card/Card";

import debounce from "lodash/debounce";

import Auth from "@/store/auth";
import { DONO, CORRETOR, LIDER } from '@/constants/funcionarioCargo.js';


export default {

    name: "clientes-simulador",

    components: {
        BotaoRemover,
        Card,
        FiltroPorAutores,
        FiltroPorData,
        FiltroPorLead,
        FullLoading,
        LeadCard,
        LeadCardItem,
        Pagination,
        TituloPagina
    },

    created() {
        this.paginar(1)
    },


    computed: {

        cargo() {
            return Auth.getCargoUsuario();
        },
        cargoCorretor() {
            return Auth.state.user.pessoa.funcionario.funcionario_cargo_id === CORRETOR;
        },
        cargoLider() {
            return Auth.state.user.pessoa.funcionario.funcionario_cargo_id === LIDER;
        },

        cargoDono() {
            return this.cargo == DONO;
        }
    },

    data() {

        const {funcionarios_ids, pessoa_nome, data_ini, data_fim} = this.$route.query;

        return {
            carregando: false,
            pesquisa: {
                pessoa_nome: pessoa_nome,
                funcionarios_ids: funcionarios_ids ? [...funcionarios_ids] : [],
                data_ini: data_ini,
                data_fim: data_fim,
            },
            pedidos: {
                data: [],
            }
        }
    },

    methods: {

        detectarUsoSimulador(cliente) {

            const usou = [
                'aporte_previdencia',
                'necessidade_segurado',
                'necessidade_investimento',
                'renda',
                'seguro'
            ].some(key => {
                return cliente.resumo_necessidades[key] > 0
            });

            this.$set(cliente, 'usou_simulador', usou || cliente.quantidade_questionario_investidor_resposta > 0 || cliente.contribuicao_previdencia_privada);
        },

        paginar: debounce(async function (pagina)
        {
            this.carregando = true;

            const params = {
                page: pagina,
                limit: 10,
                ...this.pesquisa
            };

            const {data: {result: {data: pedidos}}} = await api.get('pedido/simulador', {params});

            pedidos.data.forEach(pedido => {
                this.detectarUsoSimulador(pedido.cliente_has_produto.cliente);
            })

            this.pedidos = pedidos;

            this.carregando = false;

        }, 500),
    }
}
</script>



<style lang="scss" scoped>

@import "@/assets/sass/simulador.scss";


.btn-default{

  background-color: var(--color-primary) !important;

  .btn-icon-circle{
    margin-left: 5px;
    height: 15px;
    width: 15px;
    border-radius: 50%;
    background-color: #fff;
    animation: pulse 1s ease infinite;

    &.active{
        background-color: orange;
        animation: none;
    }
  }

  &.btn-flex{
        display: inline-flex;
        text-align: center;
        justify-content: center;
        align-items: center;
  }
}


</style>



// WEBPACK FOOTER //
// src/components/lead/ClientesSimulador.vue